import React from 'react'
import { Link } from "react-router-dom";
import { Field, reduxForm, reset } from 'redux-form'

import Svg from '../components/Svg';

const renderField = ({ input, className, label, type, meta: { touched, error, warning } }) => {
	if (touched && error) {
		return (
			<div className="input-field">
				<label className="is-invalid-label">
			    <input 
			    	{...input} 
			    	type={type}
			    	className="is-invalid-input" 
			    	placeholder={label} />
			    <span className="form-error is-visible" id="uuid">{error}</span>
			  </label>
		  </div>
		)
	}

	return (
		<div className="input-field">
		  <label>
		    <input {...input} placeholder={label} type={type} />
		  </label>
	  </div>
	)
}

const validate = {
	first_name: value => value ? undefined : 'First Name is required',
	last_name: value => value ? undefined : 'Last Name is required',
	mobile_number: value => value ? undefined : 'Mobile Number is required',
	email: value => value ? undefined : 'Email is required',
	isEmail: value => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? undefined : 'Your Email appears to be invalid',
}

const FindMeForm = props => {
	const { handleSubmit, errors, submitting, pristine, artist } = props
	
	return (
		<form id="find-me-form" onSubmit={ handleSubmit }>
			{ errors 
				? <p className="error-message"><i className="fa fa-exclamation-circle"></i> {errors}</p> 
				: ''}
			{ artist && !artist.length 
				? <p className="error-message"><i className="fa fa-exclamation-circle"></i> Sorry we couldn’t find an account for you, please select Create New Account button below</p> 
				: ''}
		
			<Field 
			type="text"
			name="first_name"
			component={renderField}
			label="First Name" />
			
			<Field 
			type="text"
			name="last_name"
			component={renderField}
			label="Last Name" />

			<Field 
			type="text"
			name="mobile_number"
			component={renderField}
			label="Your Mobile/Cell" />

			<Field 
			type="email"
			name="email"
			component={renderField}
			label="Your Email" />

			<button className="button primary" 
				type="submit" 
				disabled={pristine || submitting}>
					{submitting ? 'Searching Artist...' : 'Find Me' }
			</button>
		</form>
	)	
}

export default reduxForm({
  // a unique name for the form
  form: 'FindMeForm',
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  onSubmitSuccess: (result, dispatch) => dispatch(reset('FindMeForm'))
})(FindMeForm)





// WEBPACK FOOTER //
// ./src/components/FindMeForm.js